import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ItensFotosViewModel } from 'models/confeccoes/ItensFotosViewModel';

@Component({
  selector: 'app-carousel-galery',
  templateUrl: './app-carousel-galery.component.html',
  styleUrls: ['./app-carousel-galery.component.css']
})
export class AppCarouselGaleryComponent implements OnInit {
  @Input() listaImagem: ItensFotosViewModel[] = [];
  @Input() carregando = false;
  @Input() transitionMs = 350;


  currentIndex = 0;

  ngOnInit(): void {

  }

  get transform(): string {
    return `translateX(-${this.currentIndex * 100}%)`;
  }

  navigate(direction: string) {
    if (!this.listaImagem?.length) return;
    if (direction === 'F') {
      this.prev();
    } else if (direction === 'B') {
      this.next();
    }
  }

  prev() {
    if (!this.listaImagem?.length) return;
    if (this.currentIndex === 0) {
      this.currentIndex = this.listaImagem.length - 1;
      return;
    };
    this.currentIndex -= 1;
  }

  next() {
    if (!this.listaImagem?.length) return;
    if (this.currentIndex >= this.listaImagem.length - 1) {
      this.currentIndex = 0;
      return;
    };
    this.currentIndex += 1;
  }

  changeIndex(index: number) {
    if (index < 0 || index >= this.listaImagem.length) return;
    this.currentIndex = index;
  }
}
